import React, { useState } from "react";
import Pro from "./pro";
import Perso from "./perso";

function Experiences(){
    const [buttonName, setButtonName] = useState('Voir mes expériences perso');
    const [content, setContent] = useState(<Pro/>);

    const handleButtonClick = () => {
        setTimeout(() => {
            if (buttonName === 'Voir mes expériences pro'){
                setButtonName('Voir mes expériences perso');
                setContent(<Pro/>);
            } else {
                setButtonName('Voir mes expériences pro');
                setContent(<Perso/>);
            }
        }, 400)
    }

    return(
        <section id="exp">
            <h2 className="fs-40">Expériences</h2>

            <div className="flex-wrap">
                <button className="cta" key={buttonName} onClick={handleButtonClick}>
                    <span>{buttonName}</span>
                    <img className="white-arr" src="/img/icons/white-arrow.svg" />
                </button>
            </div>

            {content}
        </section>
    )
}

export default Experiences
